import React, { useEffect, useState } from 'react';
import useHydrated from '../hooks/useHydrated';
import {
  CONSENT_EVENT,
  getAnalyticsConsent,
  isAnalyticsConfigured,
  setAnalyticsConsent,
} from '../analytics';

function AnalyticsConsent() {
  const hydrated = useHydrated();
  const [consent, setConsent] = useState(getAnalyticsConsent);

  useEffect(() => {
    const syncConsent = (event) => setConsent(event.detail);
    window.addEventListener(CONSENT_EVENT, syncConsent);
    return () => window.removeEventListener(CONSENT_EVENT, syncConsent);
  }, []);

  // The stored answer only exists in the browser, so the prompt waits for
  // hydration rather than appearing in (or vanishing from) prerendered HTML.
  if (!hydrated || !isAnalyticsConfigured() || consent) return null;

  return (
    <aside
      className="analytics-consent"
      aria-label="Optional analytics preference"
    >
      <p>
        May Virgil measure public page visits, how you found us, and signup and
        download steps using an anonymous identifier? We do not include your
        name, email, writing, payment data, full referral URLs, or download links.
      </p>
      <div className="analytics-consent-actions">
        <button
          type="button"
          className="cta-button"
          onClick={() => setAnalyticsConsent('granted')}
        >
          Allow analytics
        </button>
        <button
          type="button"
          className="cta-button secondary"
          onClick={() => setAnalyticsConsent('denied')}
        >
          No thanks
        </button>
        <a href="/privacy">Privacy policy</a>
      </div>
    </aside>
  );
}

export default AnalyticsConsent;
